import React from 'react'
import styled from '@emotion/styled'
import { InfiniteData } from '@tanstack/react-query'
import { SkeletonLoader } from '@core/Areas/BetLoop/Components/Common/SkeletonLoader'
import type { BetLoopProfile } from '@core/Areas/BetLoop/types'
import type { FollowButtonLocation } from '@core/Areas/BetLoop/Components/Common/FollowButton/types'
import { ProfileItem } from './Components/ProfileItem'

type ProfilesListProps = {
  data?:
    | InfiniteData<BetLoopProfile[], unknown>
    | undefined
    | InfiniteData<BetLoopProfile[] | undefined, unknown>
    | undefined
  isLoading: boolean
  LoadMoreButton: () => React.JSX.Element | null
  searchQuery?: string
  location: FollowButtonLocation
  shouldShowSkeletonLoader?: boolean
}

export const ProfilesList: React.FC<ProfilesListProps> = ({
  data,
  isLoading,
  LoadMoreButton,
  searchQuery,
  location,
  shouldShowSkeletonLoader = true,
}) => {
  if (shouldShowSkeletonLoader && (isLoading || !data)) {
    return <SkeletonLoader headerCount={25} showOnlyHeader />
  }

  return (
    <ListContainerStyled>
      {data?.pages.map(profileList =>
        profileList?.map(profile => (
          <ProfileItem
            profile={profile}
            key={profile.id}
            location={location}
            searchQuery={searchQuery}
          />
        ))
      )}

      <LoadMoreButton />
    </ListContainerStyled>
  )
}

// ======
// Styles
// ======

const ListContainerStyled = styled.div({
  display: 'flex',
  flexDirection: 'column',
  position: 'relative',
})
